"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ErrorMessageType {
    getValidationType() {
        return this._validationType;
    }
    setValidationType(value) {
        this._validationType = value;
        return this;
    }
    getFieldType() {
        return this.fieldType;
    }
    setFieldType(value) {
        this.fieldType = value;
        return this;
    }
    getFieldName() {
        return this.fieldName;
    }
    setFieldName(value) {
        this.fieldName = value;
        return this;
    }
    setMessage(value) {
        this.message = value;
        return this;
    }
    getMessage() {
        return this.message;
    }
}
exports.default = ErrorMessageType;
